var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useView } from '../hooks/use-view';
import { EntityView } from './entity-view';
import { useEntityGptComponent } from '../hooks/use-entity-gpt-component';
import { useEntityContentTabs } from '../hooks/use-entity-content-tabs';
var cls = classNames('entity-view-tabs-content');
export var EntityViewMainDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  NAME: 'EntityViewMain',
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var EntityViewMain = function (props) {
  var _a;
  var componentProps = useComponentProps(My.NAME, EntityViewMainDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity;
  var color = entity.color,
    _b = entity.entityViews,
    entityViews = _b === void 0 ? [] : _b,
    _c = entity.entityType,
    entityType = _c === void 0 ? {} : _c;
  var useAi = entityType.useAi;
  var tabs = useEntityContentTabs(entity);
  // TODO - change this to main only.
  var showView = useView(entity.path, (_a = tabs.find(function (tab) {
    return tab.isDefault;
  })) === null || _a === void 0 ? void 0 : _a.id).showView;
  var GptLayout = useEntityGptComponent();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, useAi && GptLayout && showView('ai') && React.createElement(GptLayout, {
    entity: entity
  }), tabs.map(function (view) {
    if (showView(view.id)) {
      return React.createElement(EntityView, {
        key: view.id,
        entity: entity,
        view: view.id
      });
    }
  }));
};
EntityViewMain.cls = cls;
var templateObject_1, templateObject_2;